import _styled, { default as _styled2 } from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { FooterBottomLink } from "~/features/app/app-footer/footer-bottom-links/footer-bottom-link";
const fragment = graphql(`
  fragment FooterBottomLinks on footerBottomLinks_NeoField {
    ...FooterBottomLink
  }
`);
type Props = {
  links: FragmentType<typeof fragment>[];
};
export function FooterBottomLinks(props: Props) {
  const {
    links: _links
  } = props;
  const links = useFragment(fragment, _links);
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledUl>
      {links.map((link, idx) => <li key={idx}>
          <FooterBottomLink {...link} />
        </li>)}
      <li>
        <_StyledButton className="iubenda-cs-preferences-link">
          Your Privacy Choices
        </_StyledButton>
      </li>
    </_StyledUl>;
}
var _StyledUl = _styled("ul").withConfig({
  componentId: "sc-sf-149voay-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "center",
  "justifyContent": "center",
  "columnGap": "4rem",
  "rowGap": "2.4rem",
  "@media (min-width: 1024px)": {
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "columnGap": "8rem"
  }
});
var _StyledButton = /*#__PURE__*/_styled2("button").withConfig({
  displayName: "footer-bottom-links___StyledButton",
  componentId: "sc-16cslo6-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "transitionProperty": "opacity",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out",
  "@media (hover: hover)": {
    "&:hover": {
      "opacity": "0.6"
    }
  },
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
});